module.exports = __webpack_public_path__ + "img/database.485334d4.svg";